import { render, staticRenderFns } from "./StepFinish.vue?vue&type=template&id=0985affe&scoped=true&"
import script from "./StepFinish.vue?vue&type=script&lang=js&"
export * from "./StepFinish.vue?vue&type=script&lang=js&"
import style0 from "./StepFinish.vue?vue&type=style&index=0&id=0985affe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985affe",
  null
  
)

export default component.exports